import { motion } from "motion/react";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	delay: number;
};

export const FadeInTopAnimation: FC<Props> = (props) => {
	return (
		<motion.div
			initial={{ y: 20, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{
				duration: 0.4,
				delay: props.delay,
			}}
		>
			{props.children}
		</motion.div>
	);
};
